import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase';
import { setupNotifications } from './firebaseMessaging';
import LoginPage from './components/LoginPage';
import Game from './components/Game';
import GardenGame from './components/GardenGame';
import OurPlant from './components/OurPlant';
import LoveLetters from './components/LoveLetters';
import Profile from './components/Profile';
import Mood from './components/Mood';
import Journal from './components/Journal';
import Dates from './components/Dates';
import Navbar from './components/Navbar';
import Countdowns from './components/Countdowns';
import Tinder from './components/Tinder';
import Home from './components/Home';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [theme, setTheme] = useState(() => {
    // Get theme from localStorage or default to 'light'
    return localStorage.getItem('theme') || 'light';
  });

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
      if (currentUser) {
        // If user is logged in, set up notifications
        setupNotifications();
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    // Apply theme to body and save to localStorage
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  if (loading) {
    return <div>Loading...</div>; // Or a nice loading spinner
  }

  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
          <Route path="/" element={user ? <Game toggleTheme={toggleTheme} currentTheme={theme} /> : <Navigate to="/login" />} >
            <Route index element={<Home />} />
            <Route path="love-letters" element={<LoveLetters />} />
            <Route path="our-plant" element={<OurPlant />} />
            <Route path="mood" element={<Mood />} />
            <Route path="journal" element={<Journal />} />
            <Route path="dates" element={<Dates />} />
            <Route path="profile" element={<Profile />} />
            <Route path="countdowns" element={<Countdowns />} />
            <Route path="tinder" element={<Tinder />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;